export default "__VITE_ASSET__CKEtGr2A__"